module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS14.541b37ad.jpg";